import React from "react";
import "twin.macro";
import { StaticImage } from "gatsby-plugin-image";

const SponsorBanner: React.FC = () => {
  return (
    <a
      href="https://www.dronfield-dolphins.co.uk/"
      target="_blank"
      rel="noopener noreferrer"
      tw="flex items-center justify-center bg-dsrTeal-700 hover:bg-dsrTeal-800 transition-colors duration-200 py-2 sm:py-3 px-4"
    >
      <StaticImage
        src="../../images/dronfield-dolphins-logo.png"
        alt="Dronfield Dolphins Swimming Club"
        placeholder="blurred"
        layout="fixed"
        width={32}
        height={32}
        tw="h-6 w-6 sm:h-8 sm:w-8 flex-shrink-0"
      />
      <span tw="text-white text-xs sm:text-sm md:text-base font-semibold ml-2 sm:ml-3">
        Proud Sponsors of Dronfield Dolphins Swimming Club
      </span>
    </a>
  );
};

export default SponsorBanner;
